import * as React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
const SvgGateIn = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    props,
    <path d="M10 2h4v7h-4V2ZM18 16l4-4-4-4v3H8a1 1 0 1 0 0 2h10v3ZM14 15h-4v7h4v-7Z" />
  )
export default SvgGateIn
